// パーサーが使用するインターフェースとエラーコードを定義


// CsvErrorCode
export const CsvErrorCode = {
    FILE_TOO_LARGE: "FILE_TOO_LARGE", // ファイルが大きすぎる
    FILE_NOT_CSV: "FILE_NOT_CSV", // .csvでない
    EMPTY: "EMPTY", // 空(ヘッダ行すら存在しない)
    INVALID_ENCODING: "INVALID_ENCODING", // ファイル読み取りに失敗
    QUOTE_NOT_CLOSED: "QUOTE_NOT_CLOSED", // ダブルクォートが閉じられていないため解析に失敗した
    HEADER_DUPLICATED: "HEADER_DUPLICATED", // ヘッダに重複があります
    HEADER_MISSING: "HEADER_MISSING", // ヘッダに不足があります
    PARSE_ERROR: "PARSE_ERROR", // パースエラー汎用
} as const;
export type CsvErrorCode = (typeof CsvErrorCode)[keyof typeof CsvErrorCode];

// Error
export interface CsvError {
    code: CsvErrorCode;
    message: string;
    detail?: string[];
}

// Header
export interface HeaderSpecItem {
    name: string; // CSV上のヘッダ名
    required?: boolean; // 必須かどうか
    trim?: boolean; // 該当カラムを trim するか
    mapTo?: string; // name->propatyName(asObjectのときに指定必須)
    defaultValue?: string; // 任意カラムが存在しないときのデフォルト値(asObjectのときのみ(文字列表記))
}

// Option
export interface ParseCsvOptions<T> {
    extension?: boolean; // 拡張子のチェックを行うか
    encoding?: string; // encoding指定
    maxFileSize?: number; // サイズ上限
    asObject?: boolean; // trueなら T[] にする
    existHeader?: boolean; // Headerが存在するか
    headerSpec?: HeaderSpecItem[]; // Header
    skipEmptyRow?: boolean; // 空行をスキップするか ※1行を1カラムとしてみなす場合のみ使用できる。
    noCheckQuote?: boolean; // クオートのチェックをしない ※1行を1カラムとしてみなす場合のみ使用できる。
    mapRow?: (row: Record<string, string | undefined>) => T; // 任意の mapping
}

// HeaderのParse結果
export interface HeaderCheckResult {
    duplicateHeaders: string[]; // 重複
    missingHeaders: string[]; // 欠損
    normalizedHeader: string[]; // ParseしたHeader情報
    warningHeaders?: string[]; // 仕様外の重複などの警告
}

// Csv全体のParse結果
export interface ParsedRow<T> {
    lineNumber: number;
    row: T;
}
export interface ParseCsvResult<T> {
    ok: boolean;
    errors: CsvError[];
    headerInfo?: HeaderCheckResult;
    rows?: ParsedRow<T>[];
}
